import { render, staticRenderFns } from "./addJobDialog.vue?vue&type=template&id=3870c0f7&scoped=true&"
import script from "./addJobDialog.vue?vue&type=script&lang=js&"
export * from "./addJobDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3870c0f7",
  null
  
)

export default component.exports